import React from "react"
import {
  Flex, Box, Text, Avatar, Checkbox, Tooltip,
} from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { User } from "sharedTypes"

type Props = {
  user: User
  email: boolean
  sms: boolean
  onEmailChange: (checked: boolean) => void
  onSmsChange: (checked: boolean) => void
  smsDisabled?: boolean
}

const COL_W = 10
const COL_GAP = 6

export const AlertColumnHeaders = () => (
  <Flex justify="flex-end" mb={2} pr={1}>
    <Flex gap={COL_GAP}>
      <Flex w={COL_W} justify="center" align="center" gap={1} color="gray.700">
        <Icon icon="email-plain" size={3} />
        <Text fontSize="sm" fontWeight="medium" whiteSpace="nowrap">Email</Text>
      </Flex>
      <Flex w={COL_W} justify="center" align="center" gap={1} color="gray.700">
        <Icon icon="text-sms" size={3} />
        <Text fontSize="sm" fontWeight="medium" whiteSpace="nowrap">SMS</Text>
      </Flex>
    </Flex>
  </Flex>
)

const UserAlertRow = ({
  user, email, sms, onEmailChange, onSmsChange, smsDisabled,
}: Props) => {
  const hasPhone = !!user.phone

  return (
    <Flex align="center" w="full">
      <Avatar
        size="md"
        mr={3}
        src={user.photoUrl}
        name={[user.firstName, user.lastName].join(" ")}
        flexShrink={0}
      />
      <Box flex={1} minW={0} mr={3}>
        <Text fontWeight="semibold" fontSize="lg" noOfLines={1}>
          {user.firstName} {user.lastName}
        </Text>
        <Text fontSize="sm" color="gray.700" noOfLines={1}>
          {user.email}
          {user.phone && <Text as="span" ml={2}>{user.phone}</Text>}
        </Text>
      </Box>
      <Flex flexShrink={0} gap={COL_GAP}>
        <Flex w={COL_W} justify="center">
          <Checkbox
            aria-label={`Email notification for ${user.firstName} ${user.lastName}`}
            isChecked={email}
            onChange={(e) => onEmailChange(e.target.checked)}
          />
        </Flex>
        <Tooltip
          isDisabled={hasPhone}
          label="No phone number on file"
          placement="top"
        >
          <Flex w={COL_W} justify="center">
            <Checkbox
              aria-label={`SMS notification for ${user.firstName} ${user.lastName}`}
              isChecked={sms}
              isDisabled={!hasPhone || smsDisabled}
              onChange={(e) => onSmsChange(e.target.checked)}
            />
          </Flex>
        </Tooltip>
      </Flex>
    </Flex>
  )
}

export default UserAlertRow
